import React from "react";
import {Navigate, useLocation} from "react-router";
import {routes} from "../../routing/routes";
import type {RouteSpecification} from "../../routing/routeClasses";
import {environment} from "../../env";


export const FrontEggCallbackRoute = () => {
    // This route is called by FrontEgg to store the user and token in the FrontEggContext

    // When this route is called the FrontEggRootWrapper has already stored this token

    // TODO: We can also try to login the user here, then we don't need to redirect.
    //  We would still need to show some page while this is happening though

    const location = useLocation();
    const to = routes.login;
    console.log(`FrontEgg: FrontEggCallbackRoute redirect to ${to}`, JSON.stringify(location));
    return <Navigate to={to} replace/>;
}

export const CALLBACK_ROUTE: RouteSpecification | null = environment.hasFrontegg ? [
    {wrapper: null},
    routes.frontegg_callback,
    FrontEggCallbackRoute,
    {notAuthenticated: true, name: 'CALLBACK_ROUTE'} as any,
] : null;
